"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioTileSchema = exports.default = void 0;
var RadioTiles_1 = require("./RadioTiles");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(RadioTiles_1).default; } });
Object.defineProperty(exports, "radioTileSchema", { enumerable: true, get: function () { return RadioTiles_1.radioTileSchema; } });
//# sourceMappingURL=index.js.map